// src/pages/LoanCreationPage.js
import React from 'react';
import { Card, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import LoanForm from '../components/LoanForm';
import Page from '../components/layout/Page';
import headerExtra from '../components/layout/Header';

const LoanCreationPage = () => {
  const { t } = useTranslation();

  return (
    <Page
        title={t('loanNew.title')}
        subtitle={t('loanNew.subtitle')}
        headerExtra={headerExtra}
    >
      <Space direction="vertical" size="large" className="width-100">
        <LoanForm />
      </Space>
    </Page>
  );
};

export default LoanCreationPage;
